import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/hair-type-analysis"
    path="business/products/hair-type-analysis"
    element={<AsyncPage />}
  />,
];
